import { render } from "./DynamicCustomFields.vue?vue&type=template&id=5c5c5cc8"
import script from "./DynamicCustomFields.vue?vue&type=script&lang=js"
export * from "./DynamicCustomFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__